<script setup lang="ts">
import type { ShortsSectionVariant } from './variants';

import { getSkeletonStyles, placeholderVariants } from './variants';

const props = withDefaults(
	defineProps<{
		title?: string;
		variant?: ShortsSectionVariant;
	}>(),
	{
		title: 'Descubra imóveis em vídeo',
		variant: 'dark'
	}
);

const styles = computed(() => getSkeletonStyles(props.variant));
</script>

<template>
	<section :class="styles.section">
		<div
			:class="[
				'mx-auto w-full px-5 py-11 md:px-8 md:py-[60px] lg:px-12',
				styles.containerClass
			]"
		>
			<div class="mx-auto w-full 2xl:max-w-[1440px]">
				<header :class="styles.headerClass">
					<div class="flex w-full flex-col items-start justify-between">
						<div class="relative">
							<span :class="['text-transparent', styles.titleFont]">
								{{ title }}
							</span>
							<div
								:class="[
									'absolute inset-y-0 left-0 my-auto h-5 w-[283px] md:h-8 md:w-[475px]',
									styles.placeholder
								]"
							/>
						</div>
					</div>
				</header>
				<div :class="styles.contentGap">
					<div class="flex gap-5 overflow-hidden">
						<div
							v-for="i in 6"
							:key="i"
							:class="['shrink-0', styles.carouselItemClass]"
						>
							<div :class="['aspect-9/14', placeholderVariants({ variant })]" />
						</div>
					</div>
					<div
						:class="[
							'flex h-auto w-full items-start gap-6 lg:items-center',
							styles.showCtaButton
								? 'flex-col-reverse justify-between md:flex-row'
								: 'justify-end'
						]"
					>
						<div
							v-if="styles.showCtaButton"
							:class="[
								'h-11 w-[220px] rounded-sm md:h-[52px]',
								styles.placeholder
							]"
						/>
						<div class="flex w-full items-center justify-end gap-3">
							<div :class="['flex-wrap', styles.selectorContainer]">
								<div v-for="j in 6" :key="j" :class="styles.selectorBar" />
							</div>
							<div :class="styles.arrowContainer">
								<IconMaterialSymbolsLightChevronLeft class="size-7 lg:size-8" />
								<IconMaterialSymbolsLightChevronRight
									class="size-7 lg:size-8"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
